var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/modules/_shared-key.js
// module id = NTNn
// module chunks = 5 6 7 8